import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import saveAs from 'file-saver';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-application-type-report',
  templateUrl: './application-type-report.component.html',
  styleUrls: ['./application-type-report.component.scss']
})
export class ApplicationTypeReportComponent implements OnInit {
  // @ViewChild('table1', { static: true });
  @ViewChild('tableContainer1') tableContainer1: ElementRef;
  @ViewChild('tableContainer2') tableContainer2: ElementRef;
  @ViewChild('tableContainer3') tableContainer3: ElementRef;

  exportMenuItemsT1: MenuItem[];
  exportMenuItemsT2: MenuItem[];
  exportMenuItemsT3: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];

  public userId: any;

  // public table1: Table;
  // public table2: Table;
  public dataTable0: any = [];
  public dataTableBeforeFilter: any = [];
  public dataTable1: any = [];
  public dataTable2: any = [];
  public dataTable3: any = [];
  public dataTable3Header: any;

  public loading0: boolean = false;
  public loading1: boolean = false;
  public loading2: boolean = false;
  public loading3: boolean = false;

  public showTable0: boolean = true;
  public showTable1: boolean = false;
  public showTable2: boolean = false;
  public showTable3: boolean = false;

  public selectedT1Row: any;
  public selectedT2Row: any;

  public TotalTargetDays: number = 0;
  public TotalTimeTaken: number = 0;
  public TotalExtra_Time_Taken: number = 0;
  public TotalDelay_at_Department: number = 0;
  public TotalDelay_at_farmer_end: number = 0;
  public TotalDelay_at_Vendor_end: number = 0;
  
  public delayAtVendorPresent: boolean = false;
  public programmeNamePresent: boolean = false;

  constructor(
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadTable1Data();
    this.exportMenuItemsT1 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel1(this.dataTable1, 'Time Line Report');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf1(
            this.dataTable1,
            'Time Line Report'
          );
        },
      },
    ];

    this.exportMenuItemsT2 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel2(this.dataTable2, `${this.selectedT1Row?.Application_Type} of ${this.selectedT1Row?.District}`);
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf2(
            this.dataTable2,
            `${this.selectedT1Row?.Application_Type} of ${this.selectedT1Row?.District}`
          );
        },
      },
    ];

    this.exportMenuItemsT3 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel3(this.dataTable3, 'Time Line Detail Report');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf3(
            this.dataTable3,
            'Time Line Detail Report'
          );
        },
      },
    ];
  }

  loadTable1Data(){
    this.loading0 = true;
    this.deptDashBoardService
      .getDistWiseAvgTimeConsumed()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.userId, 'District Wise Avg Time Line Report', '', new Date(), 'Success');

          if (data.length > 0) {
            this.dataTableBeforeFilter = data;

            let averageTotalAppMI = 0;
            let averageTotalAppPond = 0;
            let averageTargetDaysMI = 0;
            let averageTargetDaysPond = 0;

            data.forEach(val => {
              if(val.Application_Type == "MI Application"){
                averageTotalAppMI += val.Total_Application;
                averageTargetDaysMI += val.Target_Days;
              }
              else if(val.Application_Type == 'Pond Application'){
                averageTotalAppPond += val.Total_Application;
                averageTargetDaysPond += val.Target_Days;
              }
            })

            this.dataTable0 = [
              {
                Application_Type: 'MI Application',
                Total_Application: averageTotalAppMI,
                Total_Target_Days: averageTargetDaysMI
              },
              {
                Application_Type: 'Pond Application',
                Total_Application: averageTotalAppPond,
                Total_Target_Days: averageTargetDaysPond
              }
            ]
        
            this.dataTable2 = [];
            this.dataTable3 = [];
            this.loading0 = false;
          }
          else{
            this.dataTable0 = [];
            this.dataTable1 = [];
            this.dataTable2 = [];
            this.dataTable3 = [];
            this.dataTable3Header = null;
            this.loading0 = false;
          }
        },
        error: (err) => {
          this.dataTable1 = [];
          this.dataTable2 = [];
          this.dataTable3 = [];
          this.dataTable3Header = null;
          this.loading0 = false;
          this.activityRecordService.activityRecord(this.userId, 'District Wise Avg Time Line Report', '', new Date(), err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

        },
      });
  }

  refreshTable1(){
    this.loadTable1Data();
    this.showTable1 = false;
    this.showTable2 = false;
    this.showTable3 = false;
  }

  onClickfirstTableRow(row){
    this.showTable2 = true;
    this.showTable3 = false;
    setTimeout( () => this.tableContainer2.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)
    
    this.selectedT1Row = row;
    
    let reqBody = {
      AppId: '',
      Program: row.Application_Type == 'MI Application' ? 'MI' : row.Application_Type == 'Pond Application' ? 'Pond' : '',
      District: row?.District ? row?.District : ''
    }

    this.dataTable2 = [];
    this.dataTable3 = [];
    this.dataTable3Header = null;
    this.loadTable2Data(reqBody);
  } 

  onClickSecondTableRow(row){
    this.showTable3 = true;
    setTimeout( () => this.tableContainer3.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)
    
    this.selectedT2Row = row;
    
    let reqBody = {
      AppId: row?.AppId ? row?.AppId : '',
      Program: this.selectedT1Row.Application_Type == 'MI Application' ? 'MI' : this.selectedT1Row.Application_Type == 'Pond Application' ? 'Pond' : '',
    }

    this.dataTable3 = [];
    this.dataTable3Header = null;
    this.loadTable3Data(reqBody);
  }


  loadTable2Data(reqBody ){
    this.loading2 = true;
    this.deptDashBoardService
      .getDistWiseAvgTimeConsumedProgram(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading2 = false;
          
          
          if(data.length > 0) {
            this.delayAtVendorPresent = Object.keys(data[0]).includes('Delay_at_Vendor_end');
            this.programmeNamePresent = Object.keys(data[0]).includes('ProgrammeName');

            data.forEach((data) => {
                this.TotalTargetDays += data?.TargetDays ,
                this.TotalTimeTaken += data?.TimeTaken,
                this.TotalExtra_Time_Taken += data?.Extra_Time_Taken,
                this.TotalDelay_at_Department += data?.Delay_at_Department,
                this.TotalDelay_at_farmer_end +=data?.Delay_at_farmer_end,
                this.TotalDelay_at_Vendor_end += data?.Delay_at_Vendor_end
            })
            
            this.dataTable2 = data;
            this.dataTable3 = [];
            this.dataTable3Header = null;
          }else{
            this.dataTable2 = [];
            this.dataTable3 = [];
            this.dataTable3Header = null;
          }
          
          this.activityRecordService.activityRecord(this.userId, `${this.selectedT1Row?.Application_Type} of ${this.selectedT1Row?.District}`, '', new Date(), 'Success', reqBody);

        },
        error: (err) => {
          this.dataTable2 = [];
          this.dataTable3 = [];
          this.dataTable3Header = null;
          this.loading2 = false;
          this.activityRecordService.activityRecord(this.userId, `${this.selectedT1Row?.Application_Type} of ${this.selectedT1Row?.District}`, '', new Date(), err, reqBody);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  loadTable3Data(reqBody ){
    this.loading3 = true;
    this.deptDashBoardService
      .getWorkflowAllStatusByAppId(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading3 = false;
          this.activityRecordService.activityRecord(this.userId, 'District Wise Avg Time Line Report Details', '', new Date(), 'Success', reqBody);

          if(data.length > 0) {
            this.dataTable3 = data;
            this.dataTable3Header = data[0];
          }else{
            this.dataTable3 = [];
            this.dataTable3Header = null;
          }
        },
        error: (err) => {
          this.dataTable3 = [];
          this.dataTable3Header = null;
          this.loading3 = false;
          this.activityRecordService.activityRecord(this.userId, 'District Wise Avg Time Line Report Details', '', new Date(), err, reqBody);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // Export excel and pdf
  exportExcel1(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'District': d.District,
          'Application Type': d.Application_Type,
          'Total Application': d.Total_Application,
          'Target Days': d.Target_Days,
          'Average Time Taken (days)': d.Average_Time_Taken,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  exportExcel2(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'AppId': d.AppId,
          'ProgrammeName': d?.ProgrammeName,
          'LastAction': d.LastAction,
          'LastLevelId': d.LastLevelId,
          'Target Days': d.TargetDays,
          'Time Taken': d.TimeTaken,
          'Extra Time Taken': d.Extra_Time_Taken,
          'Delay at Department End': d.Delay_at_Department,
          'Delay at farmer End': d.Delay_at_farmer_end,
          'Delay at Vendor End': d.Delay_at_Vendor_end,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  exportExcel3(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Action': d.Action,
          'Level_Id': d.Level_Id,
          'UserName': d.UserId,
          'TargetDays': d.TargetDays,
          'TimeTaken': d.TimeTaken,
          'AssignedDate': d.AssignedDate,
          'Action_Date': d.Action_Date,
          'Status': d.Status,
          'Remarks': d.Remarks,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf1(modelData, filename) {
    this.cols = [
      { field: 'District', header: 'District' },
      { field: 'Application_Type', header: 'Application_Type' },
      { field: 'Total_Application', header: 'Total_Application' },
      { field: 'Target_Days', header: 'Target_Days' },
      { field: 'Average_Time_Taken', header: 'Average_Time_Taken' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 10 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }

  downloadSheetAsPdf2(modelData, filename) {
    this.cols = [
      { field: 'AppId', header: 'AppId' },
      { field: 'ProgrammeName', header: 'ProgrammeName' },
      { field: 'LastAction', header: 'LastAction' },
      { field: 'LastLevelId', header: 'LastLevelId' },
      { field: 'TargetDays', header: 'TargetDays' },
      { field: 'TimeTaken', header: 'TimeTaken' },
      { field: 'Extra_Time_Taken', header: 'Extra_Time_Taken' },
      { field: 'Delay_at_Department', header: 'Delay at Department End' },
      { field: 'Delay_at_farmer_end', header: 'Delay at Farmer End' },
      { field: 'Delay_at_Vendor_end', header: 'Delay at Vendor End' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }

  downloadSheetAsPdf3(modelData, filename) {
    this.cols = [
      { field: 'Action', header: 'Action' },
      { field: 'Level_Id', header: 'Level_Id' },
      { field: 'UserId', header: 'UserName' },
      { field: 'TargetDays', header: 'TargetDays' },
      { field: 'TimeTaken', header: 'TimeTaken' },
      { field: 'AssignedDate', header: 'AssignedDate' },
      { field: 'Action_Date', header: 'Action_Date' },
      { field: 'Status', header: 'Status' },
      { field: 'Remarks', header: 'Remarks' },      
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }


  onClickZeroTableRow(val){   
    this.dataTable1 = [];
    this.dataTable2 = [];
    this.dataTable3 = [];
    this.dataTable3Header = null;

    this.showTable1 = true;
    this.showTable2 = false;
    this.showTable3 = false;
    this.loading1 = true;

    setTimeout( () => this.tableContainer1.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)

    if(this.dataTableBeforeFilter.length > 0){
      if(val.Application_Type == 'MI Application'){
        this.dataTable1 = this.dataTableBeforeFilter.filter(item => item.Application_Type == 'MI Application');
      }
      else if(val.Application_Type == 'Pond Application'){
        this.dataTable1 = this.dataTableBeforeFilter.filter(item => item.Application_Type == 'Pond Application');
      }
      else{
        this.dataTable1 = [];
      }
      this.loading1 = false;
    }
    else{
      this.dataTable1 = [];
      this.loading1 = false;
    }
  }
}
